// src/services/collaboratorsService.js
import { getAuthHeader } from "./authService";

/** Dato quemado (institución) — NO cambiar */
export const INSTITUCION_ID = "16020324-f0ea-4319-905c-5a30618ce9f5";
/**
 * API base:
 *  - GET (listar por institución): http://localhost:3001/api/v1/users/:institucion_id
 *  - POST/PUT/DELETE (CRUD):      http://localhost:3000/api/v1/users/...
 */
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/users`;

/**
 * Helpers
 */
function jsonOrEmpty(res) {
  return res.json().catch(() => ({}));
}
function ensureOk(res, data) {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
}
function cleanPayload(obj) {
  // elimina undefined / null / "" si corresponde (respetando false/0/true)
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
}

/**
 * Listar colaboradores por institución
 */
export async function listCollaborators() {
  const res = await fetch(`${BASE_URL}/${INSTITUCION_ID}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await jsonOrEmpty(res);
  ensureOk(res, data);
  // La API podría responder {data: []} o directamente [];
  return Array.isArray(data) ? data : data?.data ?? [];
}


export async function createCollaborator(form) {
  const payload = cleanPayload({
    email: form.email,
    password: form.password, // requerido en creación
    nombres: form.nombres,
    apellidos: form.apellidos,
    rol_id: form.rol_id, // debe venir del formulario
    telefono: form.telefono,
    institucion_id: INSTITUCION_ID, // también va en body
    es_colaborador: true,
    cedula: form.cedula,
    fecha_nacimiento: form.fecha_nacimiento, // "YYYY-MM-DD"
    direccion: form.direccion,
    inicio_contrato: form.inicio_contrato,
    fin_contrato: form.fin_contrato,
    observaciones: form.observaciones,
  });

  const res = await fetch(`${BASE_URL}/${INSTITUCION_ID}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  const data = await jsonOrEmpty(res);
  ensureOk(res, data);
  // puede devolver {data: {...}} o {...}
  return data?.data ?? data;
}

/**
 * Actualizar colaborador por id
 */
export async function updateCollaborator(id, form) {
  const payload = cleanPayload({
    email: form.email,
    nombres: form.nombres,
    apellidos: form.apellidos,
    rol_id: form.rol_id,
    telefono: form.telefono,
    es_colaborador: true,
    cedula: form.cedula,
    fecha_nacimiento: form.fecha_nacimiento,
    direccion: form.direccion,
    inicio_contrato: form.inicio_contrato,
    fin_contrato: form.fin_contrato,
    observaciones: form.observaciones,
  });

  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  const data = await jsonOrEmpty(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

/**
 * Eliminar colaborador por id
 */
export async function deleteCollaborator(id) {
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await jsonOrEmpty(res);
  ensureOk(res, data);
  return true;
}
